/**
 * What the answer itself said about a part (2026-09-06; owner: "These
 * descriptions are not very helpful esp in the context of the chat and the
 * session"): the sentences of the newest answer that name the part, so the
 * dock reads in the conversation's own words before the part's generic
 * line. Pure and cheap: a sentence split and a case-insensitive search.
 */

const QUOTES_MAX = 2;

/** Sentences of `text` that mention `label`, at most two, trimmed. */
export function answerQuotes(text: string | null | undefined, label: string): string[] {
  if (text === null || text === undefined || label.trim().length === 0) return [];
  const needle = label.trim().toLowerCase();
  const plain = text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/[*_`#>]/g, '')
    .replace(/\s+/g, ' ');
  const sentences = plain.split(/(?<=[.!?])\s+(?=[A-Z0-9"'(])/);
  const found: string[] = [];
  for (const sentence of sentences) {
    const s = sentence.trim();
    if (s.length < 12 || !s.toLowerCase().includes(needle)) continue;
    found.push(s.length > 240 ? `${s.slice(0, 237).trimEnd()}...` : s);
    if (found.length >= QUOTES_MAX) break;
  }
  return found;
}
